const initialState = {};

export default function action(state = initialState, action) {

    let newState = naiveShallowCopy(state);

    switch (action.type) {

        case "CHANGE_NOTE":

            newState[action.question] = {
                text: action.payload,
                question: action.question,
                form: action.form,
                test: action.test
            };

            return newState;
        case "ADD_NOTES":

            action.payload.question_sections.forEach(section => {
                section.question_groups.forEach(group => {
                    group.questions.forEach(question => {
                        newState[question.id] = {
                            text: typeof question.question_note[0] !== "undefined" ? question.question_note[0].text : "",
                            question: question.id,
                            form: action.payload.id,
                            test: action.test
                        };
                    })
                })
            });

            return newState;
        default:
            return state;
    }
}

/**
 * This function will copy object without any reference
 * so in our case, redux will detect change, since it does not
 * detect changes in nested objects, like our data is
 *
 * @param original
 * @returns {{}}
 */
function naiveShallowCopy(original) {
    let clone = {};
    let key;
    for (key in original) {
        clone[key] = original[key];
    }
    return clone;
}


// WEBPACK FOOTER //
// ./src/redux/reducers/notes.js